import { render } from "./PaneContainer.vue?vue&type=template&id=1db00a58&scoped=true&ts=true"
import script from "./PaneContainer.vue?vue&type=script&lang=ts"
export * from "./PaneContainer.vue?vue&type=script&lang=ts"

import "./PaneContainer.vue?vue&type=style&index=0&id=1db00a58&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db00a58"]])

export default __exports__